module.exports = __webpack_public_path__ + "img/tuopu.b5d490b6.png";